import { inject } from '@angular/core';
import { signalStore, withFeature, withProps, withState } from '@ngrx/signals';
import { UserControllerService } from '@api/client';
import { useAppVersion } from './features/app-version.feature';
import { useCurrentUser } from './features/current-user.feature';
import { useLanguage } from './features/language.feature';

export const SharedStore = signalStore(
  { providedIn: 'root' },
  withState({}),
  withProps(() => ({
    _usersService: inject(UserControllerService),
  })),
  withFeature(useCurrentUser),
  withFeature(useLanguage),
  withFeature(useAppVersion),
);
